import AspectRatio from 'react-aspect-ratio';
import ReactPlayer from "react-player/file";

const playerConfig = {
	file: {
		hlsVersion: '0.14.7'
	}
};

export default function VideoPlayerBig({ value }) {
	return <AspectRatio ratio={value.width / value.height}>
		<ReactPlayer
			playing
			controls
			url={value.hls_link}
			width='100%'
			height='100%'
			config={playerConfig}
		/>
	</AspectRatio>;
}
